import WgptBotEvalResultsAPI from '../../api/wgpt/botEvalResults';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
  },
};

export const getters = {
  getResults($state) {
    return $state.records;
  },
  getResult: $state => id => {
    return $state.records.find(record => record.id === Number(id)) ?? {};
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { botId, page = 1, criticalOnly = false }) => {
    commit(types.SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG, { isFetching: true });
    try {
      const params = { page, per_page: 15 };
      if (criticalOnly) params.critical_only = 'true';
      const { data } = await new WgptBotEvalResultsAPI(botId).get(params);
      commit(types.SET_WGPT_BOT_EVAL_RESULTS, data.data);
      commit(types.SET_WGPT_BOT_EVAL_RESULTS_META, data.meta);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG, { isFetching: false });
    }
    return null;
  },
  show: async ({ commit }, { botId, id }) => {
    commit(types.SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await new WgptBotEvalResultsAPI(botId).show(id);
      // Update the record in the list with scores data
      const index = state.records.findIndex(r => r.id === data.id);
      if (index >= 0) {
        state.records.splice(index, 1, data);
      } else {
        state.records.push(data);
      }
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG, {
        isFetchingItem: false,
      });
    }
    return null;
  },
};

export const mutations = {
  [types.SET_WGPT_BOT_EVAL_RESULTS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_BOT_EVAL_RESULTS]($state, data) {
    $state.records = data;
  },
  [types.SET_WGPT_BOT_EVAL_RESULTS_META]($state, data) {
    $state.meta = {
      currentPage: data.current_page,
      totalPages: data.total_pages,
      totalCount: data.total_count,
    };
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
